import getPageNumberForShopId from './getPageNumberForShopId';
import getSelectedShopId from './getSelectedShopId';

export default state => getPageNumberForShopId(getSelectedShopId(state))(state);
